import { Game } from '../../classes/game';
import { GameType } from '../../classes/game-type';

export const GameTypes: GameType[] = [
  { id: 1, name: 'Gestion' },
  { id: 2, name: 'MMORPG' },
  { id: 3, name: 'JDR sur papier' },
  { id: 4, name: 'Stratégie' },
  { id: 5, name: 'FPS' },
  { id: 6, name: 'Bac a sable' },
  { id: 7, name: 'Plateaux' },
];

export const Games: Game[] = [
  { id: 1, name: 'Evolving World', type: GameTypes[0] },
  { id: 2, name: 'Public Transport Link', type: GameTypes[0] },
  { id: 3, name: 'Black Wings Online', type: GameTypes[1] },
  { id: 4, name: 'Elyfera Rosea', type: GameTypes[2] },
];


// WEBPACK FOOTER //
// ./src/app/data-test/mock-games/mock-games.ts